import borders from "assets/theme/base/borders";
import boxShadows from "assets/theme/base/boxShadows";

const { borderRadius } = borders;
const { xxl } = boxShadows;

const dialog = {
  styleOverrides: {
    paper: {
      borderRadius: borderRadius.lg,
      boxShadow: xxl,
      // Cap at viewport so DialogContent (flex child) can claim the
      // remaining space and scroll. Without this, tall modals overflow
      // the bottom of short viewports (laptop windows, tablet portrait)
      // and clip their action buttons. Per-modal sx / PaperProps still
      // wins because instance styles outrank styleOverrides.
      maxHeight: "calc(100% - 64px)",
      display: "flex",
      flexDirection: "column",
    },

    paperFullScreen: {
      borderRadius: 0,
      maxHeight: "100%",
    },
  },
};

export default dialog;
